/* eslint-disable class-methods-use-this */
import { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import PageTitle from '../../../common/page-title/index';
import PpcSettingsForm from './ppc-settings-form';
import { getPpcSettings } from '../../../../actions/ppc';

import './styles.css';

class PpcSettings extends Component {
  UNSAFE_componentWillMount() {
    const { dispatch } = this.props;

    dispatch(getPpcSettings());
  }

  render() {
    return (
      <Container fluid className="ppc-settings">
        <Row>
          <Col lg={12}>
            <PageTitle>
              Prepaid card settings
            </PageTitle>
            <PpcSettingsForm />
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  fetched: state.brands.fetched,
  fetching: state.brands.fetching,
});

export default connect(mapStateToProps)(PpcSettings);
